import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import { Box, MenuItem, Typography } from '@material-ui/core';
import TenureChip from './TenureChip';

class SiteSelectorMenuItem extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        polygonId: PropTypes.number.isRequired,
        tenure: PropTypes.string.isRequired,
        titleNo: PropTypes.string.isRequired,
        address: PropTypes.string.isRequired,
        onClicked: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick (event) {
        this.props.onClicked(this.props.polygonId);
    }

    render () {
        const { classes, tenure, title, address } = this.props;
        return (
            <MenuItem
                className={classes.root}
                disableGutters
                onClick={this.handleClick}
            >
                <TenureChip className={classes.tenure} tenure={tenure} />
                <Box overflow="hidden">
                    <Typography className={classes.title}>{title}</Typography>
                    <Typography className={classes.address}>{address}</Typography>
                </Box>
            </MenuItem>
        );
    }
}

const style = theme => ({
    root: {
        display: 'flex',
        height: '55px',
        padding: 0,
        paddingRight: '20px'
    },
    tenure: {
        margin: '18px 20px'
    },
    title: {
        fontSize: '10px',
        color: theme.palette.text.secondary
    },
    address: {
        fontSize: '12px',
        color: theme.palette.text.primary,
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
});

export default withStyles(style)(SiteSelectorMenuItem);